import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "278",
  "slug": "spot-mexico-from-satellite-imagery",
  "title": "How to Recognise Mexico in Satellite Images",
  "excerpt": "The Baja California peninsula lies across a narrow gulf from mainland Mexico.",
  "date": "2026-04-21",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/mexico.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Baja California peninsula lies across a narrow gulf from mainland Mexico. Much of the mainland has high interior terrain between mountain belts, while Yucatán forms a broad low peninsula in the southeast. Northern dry landscapes differ from the wetter tropical south."
    },
    {
      "type": "heading",
      "text": "Baja California, the plateau, and Yucatán"
    },
    {
      "type": "paragraph",
      "text": "Compare Baja California with Yucatán. Both are peninsulas, but their shapes, relief, and positions within the surrounding seas differ."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "The Sonoran Desert extends across the US border. Tropical lowlands continue into Belize and Guatemala. Match a coast or regional mountain pattern before treating either desert or forest as evidence for a country."
    }
  ],
  "imageAlt": "Mexico regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
